import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Menu } from '@fiverr-private/orca';
import If from '../../../../lib/If';
import { user } from '../../../../PropTypes';
import { SellerLogoDashboardLink } from '../../../LogoMakerLinks';
import { FiverrGoBadge } from '../../../FiverrGoLinks/FiverrGoBadge';
import {
    SellerOrdersLink,
    SellerGigsLink,
    SellerEarningsLink,
    SellerProfileLink,
    SellerManageCatalogLink,
    SellerBriefsLink,
    SellerResellingDashboardLink,
} from '../../../SellerLinks';
import SellerDropdown from '../../SellerDropdown';

const MyBusiness = (_props, { user }) => (
    <SellerDropdown
        triggerLabel={<I18n k="header.submenu.my_business" />}
        menu={
            <Menu className="seller-menu">
                <Menu.Item>
                    <SellerOrdersLink sellerId={user.id} sellerUsername={user.username} />
                </Menu.Item>
                <If condition={user.dynamicMatchingEligibility}>
                    <Menu.Item>
                        <SellerBriefsLink sellerId={user.id} />
                    </Menu.Item>
                </If>
                <Menu.Divider />
                <Menu.Item>
                    <SellerGigsLink sellerId={user.id} sellerUsername={user.username} />
                </Menu.Item>
                <If condition={user.isSellerRolesVisible}>
                    <Menu.Item>
                        <SellerManageCatalogLink sellerId={user.id} />
                    </Menu.Item>
                </If>
                <If condition={!!user.sellerResellingEligible}>
                    <Menu.Item>
                        <SellerResellingDashboardLink sellerId={user.id} />
                    </Menu.Item>
                </If>
                <Menu.Item>
                    <SellerProfileLink sellerId={user.id} />
                </Menu.Item>
                <If condition={user.isSellerAiModelsVisible}>
                    <Menu.Item>
                        <FiverrGoBadge isSeller={user.isSeller} showFitNewBadge />
                    </Menu.Item>
                </If>
                <If condition={!!user.makersProjectEligible}>
                    <Menu.Item>
                        <SellerLogoDashboardLink sellerId={user.id} />
                    </Menu.Item>
                </If>
                <Menu.Divider />
                <If condition={!user.isPending}>
                    <Menu.Item>
                        <SellerEarningsLink sellerId={user.id} sellerUsername={user.username} />
                    </Menu.Item>
                </If>
            </Menu>
        }
    />
);

MyBusiness.contextTypes = {
    user,
};

export default MyBusiness;
